import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { MessageSquare, Target, Star, Search, Crosshair, HelpCircle, Clock, Briefcase } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: MessageSquare,
    text: 'Cómo convertir una entrevista en una conversación profesional'
  }, {
    icon: Target,
    text: 'Las 3 razones por las que hacer preguntas marca la diferencia'
  }, {
    icon: Star,
    text: 'Cómo destacar frente a otros candidatos y ser más memorable'
  }, {
    icon: Search,
    text: 'Cómo descubrir lo que realmente necesita la empresa'
  }, {
    icon: Crosshair,
    text: "Cómo adaptar tus respuestas para 'dar en el clavo'"
  }, {
    icon: HelpCircle,
    text: 'Qué preguntas hacer sobre retos, cultura, liderazgo y metas del puesto'
  }, {
    icon: Clock,
    text: 'Cuándo hacer tus preguntas sin esperar al final'
  }, {
    icon: Briefcase,
    text: 'Cómo vender tus capacidades con inteligencia y contexto'
  }];
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-25">
      <FadeIn data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-12 text-center tracking-tight" data-id="element-27">
          Lo que aprenderás con esta guía
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-28">
        {benefits.map((benefit, index) => {
        const Icon = benefit.icon;
        return <FadeIn key={index} delay={index * 0.1} data-id="element-29">
              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm h-full hover:shadow-md transition-shadow" data-id="element-30">
                <div className="w-12 h-12 bg-lightGray rounded-lg flex items-center justify-center mb-4" data-id="element-31">
                  <Icon className="w-6 h-6 text-emerald" data-id="element-32" />
                </div>
                <p className="text-navy font-medium leading-snug" data-id="element-33">
                  {benefit.text}
                </p>
              </div>
            </FadeIn>;
      })}
      </div>
    </section>;
}